export default __webpack_public_path__ + "static/media/joint-head-tresurer.a95f6464.jpg";